import { render, staticRenderFns } from "./newAudioBook.vue?vue&type=template&id=3f08d594&"
import script from "./newAudioBook.vue?vue&type=script&lang=js&"
export * from "./newAudioBook.vue?vue&type=script&lang=js&"
import style0 from "./newAudioBook.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports